import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { HolidayService } from 'app/services/models/holiday.service';
import { KindService } from 'app/services/models/kind.service';
import { PersonLeaveService } from 'app/services/models/person-leave.service';
import { PersonService } from 'app/services/models/person.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-person-leave',
  templateUrl: './person-leave.component.html',
  styleUrls: ['./person-leave.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PersonLeaveComponent implements OnInit {
  @Input() data: { personId: number; row: any };
  personLeaveForm: FormGroup;
  person: any = {};
  kinds: any[] = [];
  isSameDayLeave = false;

  public hoveredDate: NgbDate | null = null;
  public fromDate: NgbDate | null;
  public toDate: NgbDate | null;

  startFilterDate?: string | null = null;
  endFilterDate?: string | null = null;

  public basicTP = { hour: 0, minute: 0 };
  public basicTP2 = { hour: 0, minute: 0 };

  statusList: any[] = [
    { id: 1, name: "Onay bekleniyor." },
    { id: 2, name: "Onaylandı" },
    { id: 3, name: "Reddet" }
  ];

  isDayLeave: boolean = false;
  personWorkDay: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private personLeaveService: PersonLeaveService,
    private kindService: KindService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    public formatter: NgbDateParserFormatter,
    private datePipe: DatePipe,
    private personService: PersonService,
    private holidayService: HolidayService) { }

  async ngOnInit() {
    this.personLeaveForm = this.fb.group({
      leaveDay: [1],
      kindId: [null, [Validators.required]],
      personId: this.data.personId,
      description: [null]
    });
    await this.getAllKinds();
    this.personLeaveForm.get('kindId')?.valueChanges.subscribe(async kindId => {
      if (kindId === 2034) {
        await this.getByIdWorkerAnnualDay(this.data.personId);
      } else {
        this.workerAnnualDay = null; // Diğer izin türlerinde alanı temizle
      }


      if (this.fromDate && this.toDate) {
        // await this.onDateSelection(this.fromDate); // veya herhangi bir tarih, çünkü ikisini kullanıyor
        await this.onDateSelection(null); // veya herhangi bir tarih, çünkü ikisini kullanıyor
        this.personLeaveForm.get('leaveDay')?.setValue(0);
      }

    });
    console.log(this.data);
    if (this.data.row) {

      await this.getByIdPersonLeave(this.data.row.id)
      //this.startFilterDate
    }
    if (this.data.personId != null) {
      await this.getByIdWorkerDay(this.data.personId);
    }
    await this.getHolidays();
  }

  workerAnnualDay: number = null;
  async getByIdWorkerAnnualDay(id) {
    const data = await this.personService.getByIdWorkerAnnualDay(id);
    console.log(data);
    this.workerAnnualDay = data;
  }

  async getByIdWorkerDay(id: number) {
    const result = await this.personService.getByIdWorkerDay(id);
    if (!result || result.length === 0) {
      this.toastrService.warning('Personel için çalışma günü tanımlı değil.');
    } else {
      this.personWorkDay = result;
      console.log('Çalışma günleri:', this.personWorkDay);
    }
  }

  toggleRadio(): void {
    this.isDayLeave = !this.isDayLeave; // Tersine çevir
    console.log('isDayLeave:', this.isDayLeave);
  }

  async getByIdPersonLeave(id) {
    const data = await this.personLeaveService.getByIdPersonLeave(id);
    console.log(data);
    this.person = data;
    this.personLeaveForm.patchValue({
      kindId: data.kindId,
      leaveDay: data.leaveDay,
      description: data.description
    });

    const startDate = new Date(data.startDate);
    const endDate = new Date(data.endDate);

    this.startFilterDate = startDate.toISOString().split('T')[0];
    this.endFilterDate = endDate.toISOString().split('T')[0]

    // Convert Date objects to NgbDate format (ng-bootstrap uses NgbDate for date pickers)
    this.fromDate = new NgbDate(startDate.getFullYear(), startDate.getMonth() + 1, startDate.getDate());
    this.toDate = new NgbDate(endDate.getFullYear(), endDate.getMonth() + 1, endDate.getDate());

    if (startDate.getHours() > 0) {
      this.isDayLeave = true;
    }

    this.basicTP = {
      hour: startDate.getHours(),
      minute: startDate.getMinutes()
    };

    this.basicTP2 = {
      hour: endDate.getHours(),
      minute: endDate.getMinutes()
    };
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 12);
    console.log(data);
    this.kinds = data.types;
  }

  closeModal(result: boolean = false) {
    this.activeModal.close(result);
  }

  async onSumbit() {
    if (this.personLeaveForm.valid) {
      console.log(this.personLeaveForm.value);
      console.log(this.personLeaveForm.value);
      const startDate = new Date(this.startFilterDate);
      const endDate = new Date(this.endFilterDate);
      startDate.setHours(this.basicTP.hour, this.basicTP.minute);
      endDate.setHours(this.basicTP2.hour, this.basicTP2.minute);
      console.log(startDate);
      console.log(endDate);

      const startDateUTC = new Date(Date.UTC(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate(),
        startDate.getHours(),
        startDate.getMinutes(),
        startDate.getSeconds()
      ));

      const endDateUTC = new Date(Date.UTC(
        endDate.getFullYear(),
        endDate.getMonth(),
        endDate.getDate(),
        endDate.getHours(),
        endDate.getMinutes(),
        endDate.getSeconds()
      ));

      if (this.data.row) {
        const response = await this.personLeaveService.updatePersonLeave(
          this.data.row.id,
          this.data.row.status,
          this.personLeaveForm.value.leaveDay,
          startDateUTC,
          endDateUTC,
          this.personLeaveForm.value.kindId,
          this.personLeaveForm.value.personId,
          this.personLeaveForm.value.description,
        );
        if (response.status == true) {
          this.toastrService.success(response.message);
          this.closeModal(true);
          this.personLeaveService.sendEvent(true);
          this.personService.sendEvent(true);
        } else {
          this.toastrService.error(response.message);
        }
      } else {
        const response = await this.personLeaveService.createPersonLeave(
          1,
          this.personLeaveForm.value.leaveDay,
          startDateUTC,
          endDateUTC,
          this.personLeaveForm.value.kindId,
          this.personLeaveForm.value.personId,
          this.personLeaveForm.value.description,
        );
        if (response.status == true) {
          this.toastrService.success(response.message);
          this.closeModal(true);
          this.personLeaveService.sendEvent(true);
          this.personService.sendEvent(true);
        } else {
          this.toastrService.error(response.message);
        }
      }
    }
  }

  holidays: any[] = []
  async getHolidays() {
    const data = await this.holidayService.getHoliday();
    this.holidays = data;
  }
  async onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && (date.equals(this.fromDate) || date.after(this.fromDate))) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }

    if (this.fromDate && this.toDate) {
      this.isSameDayLeave =
        this.fromDate.year === this.toDate.year &&
        this.fromDate.month === this.toDate.month &&
        this.fromDate.day === this.toDate.day;
    } else {
      this.isSameDayLeave = false;
    }

    const startDateFormatted = this.formatDate2(this.fromDate);
    const endDateFormatted = this.formatDate2(this.toDate);

    this.startFilterDate = startDateFormatted?.toString() || null;
    this.endFilterDate = endDateFormatted?.toString() || startDateFormatted?.toString();

    const start = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
    const end = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);

    const kindId = this.personLeaveForm.get('kindId')?.value;

    let usedDays = 0;

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const current = new Date(d);

      if (kindId === 2034) {
        const isSunday = current.getDay() === 0;

        // Aynı gün kontrolü (saatleri yok sayıyoruz)
        const holiday = this.holidays.find(h => {
          const holidayStart = new Date(h.startDate);
          return holidayStart.toDateString() === current.toDateString();
        });

        if (!isSunday) {
          if (holiday) {
            const holidayStart = new Date(holiday.startDate);
            const holidayEnd = new Date(holiday.endDate);

            // Tam gün tatil
            if (holidayStart.getHours() === 0 && holidayEnd.getHours() === 23) {
              continue; // hiç eklenmez
            }
            // Öğleden sonra yarım gün
            else if (holidayStart.getHours() >= 12) {
              usedDays += 0.5;
            }
            // Sabah yarım gün
            else if (holidayEnd.getHours() <= 12) {
              usedDays += 0.5;
            }
          } else {
            usedDays++;
          }
        }
      } else {
        usedDays++;
      }
    }


    this.personLeaveForm.get('leaveDay')?.setValue(usedDays);
  }

  /*
    async onDateSelection(date: NgbDate) {
      if (!this.fromDate && !this.toDate) {
        this.fromDate = date;
      } else if (this.fromDate && !this.toDate && date && (date.equals(this.fromDate) || date.after(this.fromDate))) {
        this.toDate = date;
      } else {
        this.toDate = null;
        this.fromDate = date;
      }
  
      if (this.fromDate && this.toDate) {
        this.isSameDayLeave =
          this.fromDate.year === this.toDate.year &&
          this.fromDate.month === this.toDate.month &&
          this.fromDate.day === this.toDate.day;
      } else {
        this.isSameDayLeave = false;
      }
  
      const startDateFormatted = this.formatDate2(this.fromDate);
      const endDateFormatted = this.formatDate2(this.toDate);
  
      this.startFilterDate = startDateFormatted?.toString() || null;
      this.endFilterDate = endDateFormatted?.toString() || startDateFormatted?.toString();
  
      const start = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
      const end = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);
  
      const timeDiff = end.getTime() - start.getTime();
      const diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;
      //this.personLeaveForm.get('leaveDay')?.setValue(diffDays);
  
      const kindId = this.personLeaveForm.get('kindId')?.value;
  
      let usedDays = 0;
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const current = new Date(d);
  
        if (kindId === 2034) {
          const isSunday = current.getDay() === 0;
          const isHoliday = this.holidays.some(h => {
            const holidayStart = new Date(h.startDate);
            const holidayEnd = new Date(h.endDate);
            return current >= holidayStart && current <= holidayEnd;
          });
  
          if (!isSunday && !isHoliday) {
            usedDays++;
          }
        } else {
          usedDays++;
        }
      }
  
      this.personLeaveForm.get('leaveDay')?.setValue(usedDays);
  
    }
  */
  // Saat değiştiğinde çağrılacak fonksiyon
  updateLeaveDays() {
    if (!this.fromDate || !this.toDate) return;

    const start = new Date(this.fromDate.year, this.fromDate.month - 1, this.fromDate.day);
    const end = new Date(this.toDate.year, this.toDate.month - 1, this.toDate.day);

    let usedDays = 0;
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const current = new Date(d);

      const isSunday = current.getDay() === 0;
      const isHoliday = this.holidays.some(h => {
        const holidayStart = new Date(h.startDate);
        const holidayEnd = new Date(h.endDate);
        return current >= holidayStart && current <= holidayEnd;
      });

      if (!isSunday && !isHoliday) {
        usedDays++;
      }
    }

    // Aynı gün ise saat farkına göre 8'e böl
    if (this.isSameDayLeave && this.basicTP && this.basicTP2) {
      const startMinutes = this.basicTP.hour * 60 + this.basicTP.minute;
      const endMinutes = this.basicTP2.hour * 60 + this.basicTP2.minute;
      const diffHours = (endMinutes - startMinutes) / 60; // saat farkı
      usedDays = diffHours / 8; // 8 saate böl
    } else if (this.isSameDayLeave) {
      // Saat girilmemişse varsayılan olarak 1 gün / 8 saat
      usedDays = 1 / 8;
    }

    this.personLeaveForm.get('leaveDay')?.setValue(usedDays);
  }

  formatDate2(date: NgbDate): string | null {
    if (!date) return null;

    // Convert NgbDate to JavaScript Date object
    const jsDate = new Date(date.year, date.month - 1, date.day);

    // Format the date using DatePipe
    return this.datePipe.transform(jsDate, 'yyyy-MM-dd');
  }

  /**
   * Is Hovered
   *
   * @param date
   */
  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  /**
   * Is Inside
   *
   * @param date
   */
  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  /**
   *  Is Range
   *
   * @param date
   */
  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  displayDateRange(): string {
    if (this.fromDate && this.toDate) {
      return `${this.formatter.format(this.fromDate)} - ${this.formatter.format(this.toDate)}`;
    } else if (this.fromDate) {
      return this.formatter.format(this.fromDate);
    }
    return '';
  }

}